import { Fragment, ReactNode } from 'react';

import { getErrorMessages } from '@/utils/getErrorMessages';

interface ErrorsResponse {
  errors: {
    [key: string]: Array<{ message: string; code: string }>;
  };
}
interface GenerateErrorNotificationsParams {
  errorMessage: ErrorsResponse;
  defaultErrorMessage?: string;
  statusCode?: number;
  includeCodeInErrorMessage?: boolean;
}

export const generateErrorNotifications = ({
  errorMessage,
  defaultErrorMessage,
  statusCode,
  includeCodeInErrorMessage = false,
}: GenerateErrorNotificationsParams): ReactNode[] => {
  const errorMessages = getErrorMessages(
    errorMessage,
    defaultErrorMessage,
    statusCode,
    includeCodeInErrorMessage
  );

  return errorMessages.map((errorMessage) =>
    typeof errorMessage === 'string'
      ? errorMessage
      : Object.entries(errorMessage).map(([key, value]) => (
          <Fragment key={key}>
            {key}: {value}
          </Fragment>
        ))
  );
};
